import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { useStateInRef } from '../../utils/useStateInRef';
import { BiContext, keysToSnakeCase } from './BiContext';
export function BiProvider(param) {
    let { children, logBi } = param;
    const getLogBi = useStateInRef(logBi);
    const logBiAction = useCallback((biEvent)=>{
        const { data, hierarchy } = biEvent, rest = _object_without_properties(biEvent, [
            "data",
            "hierarchy"
        ]);
        getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(_object_spread({}, data, rest))), {
            type: 'click',
            hierarchy: hierarchy !== null && hierarchy !== void 0 ? hierarchy : []
        }));
    }, []);
    const logBiPageView = useCallback((biEvent)=>{
        const { data } = biEvent, rest = _object_without_properties(biEvent, [
            "data"
        ]);
        getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(_object_spread({}, data, rest))), {
            type: 'page_view',
            hierarchy: [
                rest.pageName
            ]
        }));
    }, []);
    const logBiModalView = useCallback((biEvent)=>{
        const { data, modalName, hierarchy } = biEvent, rest = _object_without_properties(biEvent, [
            "data",
            "modalName",
            "hierarchy"
        ]);
        getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(_object_spread(_object_spread_props(_object_spread({}, data), {
            entityType: 'modal',
            entityName: modalName
        }), rest))), {
            type: 'modal_view',
            hierarchy: hierarchy !== null && hierarchy !== void 0 ? hierarchy : []
        }));
    }, []);
    const startTransaction = useCallback((input)=>{
        const startTime = performance.now();
        const { data, hierarchy } = input, rest = _object_without_properties(input, [
            "data",
            "hierarchy"
        ]);
        getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(_object_spread({}, data, rest))), {
            type: 'transaction',
            status: 'start',
            hierarchy: hierarchy !== null && hierarchy !== void 0 ? hierarchy : []
        }));
        return (endData)=>{
            const durationMs = Math.round(performance.now() - startTime);
            getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(_object_spread_props(_object_spread({}, data, endData, rest), {
                durationMs
            }))), {
                type: 'transaction',
                status: 'end',
                hierarchy: hierarchy !== null && hierarchy !== void 0 ? hierarchy : []
            }));
        };
    }, []);
    const value = useMemo(()=>({
            logBiAction,
            logBiPageView,
            logBiModalView,
            startTransaction
        }), [
        logBiAction,
        logBiPageView,
        logBiModalView,
        startTransaction
    ]);
    const getValue = useStateInRef(value);
    return /*#__PURE__*/ _jsx(BiContext.Provider, {
        value: getValue,
        children: children
    });
}
